export default __webpack_public_path__ + "static/media/Rex_Icon.a48701aa.png";